import { createRoutine } from 'redux-saga-routines'

import { IForgotPasswordState } from './forgotPassword.interface'

const initialForgotPasswordState: IForgotPasswordState = {
  loading: false,
  error: false,
  success: false,
  message: ''
}

export const forgotPassword = createRoutine('FORGOT_PASSWORD')
export const setNewPassword = createRoutine('SET_NEW_PASSWORD')

export default (state = initialForgotPasswordState, action: any) => {
  switch (action.type) {
    case forgotPassword.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: ''
      }
    case forgotPassword.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
      }
    case forgotPassword.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        message: ''
      }

    case setNewPassword.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: ''
      }

    case setNewPassword.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
      }
    case setNewPassword.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        message: ''
      }
    default:
      return { ...state }
  }
}
